import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { Menu, Row, Col } from 'antd';
import Layout from 'antd/lib/layout';

import route from 'route';

import { BizCentralIcon, NotificationIcon } from 'components/Icons';

import './Header.style.less';

const { Header } = Layout;

class HeaderBar extends PureComponent {
  _renderHeaderLogo = () => (
    <Col className="col-header" span={12}>
      <Link
        to={route.HOME}
        onClick={this.props.confirmNavigate}
        className="center-position"
      >
        <BizCentralIcon />

        <span className="apps-title">Business Central</span>
      </Link>
    </Col>
  );

  _onLogout = e => {
    this.props.confirmNavigate(e, this.props.auth0logout);
  };

  _renderHeaderMenu = () => {
    const { me } = this.props;

    return (
      <Col span={12} className="col-header">
        <Menu className="header-menu">
          <Menu.Item className="nav-header" key="admin">
            {`${get(me, 'firstname', '')} ${get(me, 'lastname', '')}`}
          </Menu.Item>
          <Menu.Item
            className="nav-header"
            onClick={this._onLogout}
            key="logout"
          >
            Logout
          </Menu.Item>
        </Menu>
      </Col>
    );
  };

  _renderMarquee = info => (
    <div className="marquee-wrapper">
      <div className="merquee-div">
        <NotificationIcon /> {info}
      </div>
    </div>
  );

  render() {
    const { info } = this.props;
    return (
      <div>
        <Header className="header-style">
          <Row type="flex" justify="start" align="middle">
            {this._renderHeaderLogo()}
            {this._renderHeaderMenu()}
          </Row>
        </Header>
        {info.length > 0 && this._renderMarquee(info)}
      </div>
    );
  }
}

HeaderBar.propTypes = {
  me: PropTypes.object.isRequired,
  confirmNavigate: PropTypes.func,
  auth0logout: PropTypes.func.isRequired,
  info: PropTypes.string,
};

export default HeaderBar;
